import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { actions as flashActions } from '@/reducers/flashMessages'

const ChunkLoadFallback = () => {
  const dispatch = useDispatch()
  const intl = useIntl()

  useEffect(() => {
    dispatch(flashActions.setFlashMessages([{
      text: intl.formatMessage({ id: 'common.chunk_load_fallback' }),
      type: 'notification'
    }]))
  }, [dispatch, intl])

  return null
}

export default ChunkLoadFallback
